"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadSchLayerMap = exports.PcbLayerMap = exports.KicadPcbLayerSelector = exports.KicadSchLayerSelector = exports.KICAD_SCH_LAYERSET = exports.KICAD_BRD_LAYERSET = void 0;
exports.getKicadDefaultLayerSets = getKicadDefaultLayerSets;
exports.getKicadSchLayerByColorType = getKicadSchLayerByColorType;
exports.getKicadSchLayerByType = getKicadSchLayerByType;
exports.getKicadSchLayers = getKicadSchLayers;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const { toArray } = sigma_engine_shared_1.Utils;
const { PcbLayerType, SchLayerType } = sigma_engine_shared_1.DesignModels;
exports.KICAD_BRD_LAYERSET = 'kicadbrd';
exports.KICAD_SCH_LAYERSET = 'kicadsch';
class KicadLayerSelector {
    filterLayers(name) {
        return this.getLayersByName(name);
    }
    getLayerByColorType(colorType, defaultType) {
        switch (colorType) {
            case 'default':
                return this.getLayerByType(defaultType);
            case 'none':
                return undefined;
            case 'background':
                return this.getLayerByType(sigma_engine_shared_1.DesignModels.SchLayerType.Background);
        }
        return this.getLayerByType(defaultType);
    }
    getLayerByType(layer) {
        const layers = this.getLayersByType(layer);
        if (layers) {
            return layers[0];
        }
        return this.getLayerByType(sigma_engine_shared_1.DesignModels.UnknownLayerType.Other);
    }
    getLayers() {
        return Array.from(this.enumerateLayers());
    }
}
class KicadSchLayerSelector extends KicadLayerSelector {
    getLayersByName(name) {
        return toArray(Array.from(exports.KicadSchLayerMap.values()).find((l) => l.name === name));
    }
    getLayersByType(type) {
        return toArray(exports.KicadSchLayerMap.get(type));
    }
    enumerateLayers() {
        return exports.KicadSchLayerMap.values();
    }
}
exports.KicadSchLayerSelector = KicadSchLayerSelector;
class KicadPcbLayerSelector extends KicadLayerSelector {
    mapLayerDetailsToLayer(details) {
        return { ...details, name: details.name[0] };
    }
    getLayersByName(value) {
        let [name, attribute] = value.split('.');
        if (!name) {
            return [];
        }
        if (!attribute) {
            attribute = '';
        }
        return exports.PcbLayerMap.filter((l) => (name === '*' || l.name.includes(name)) && l.attribute === attribute).map((l) => this.mapLayerDetailsToLayer(l));
    }
    getLayersByType(type) {
        return exports.PcbLayerMap.filter((layer) => layer.type === type).map((l) => this.mapLayerDetailsToLayer(l));
    }
    *enumerateLayers() {
        for (const layer of exports.PcbLayerMap) {
            yield this.mapLayerDetailsToLayer(layer);
        }
    }
}
exports.KicadPcbLayerSelector = KicadPcbLayerSelector;
function getKicadDefaultLayerSets() {
    return {
        [exports.KICAD_SCH_LAYERSET]: {
            type: 'layerSet',
            layerSetType: 'schematic',
            id: exports.KICAD_SCH_LAYERSET,
            layers: new KicadSchLayerSelector().getLayers(),
        },
        [exports.KICAD_BRD_LAYERSET]: {
            type: 'layerSet',
            layerSetType: 'pcb',
            id: exports.KICAD_BRD_LAYERSET,
            layers: new KicadPcbLayerSelector().getLayers(),
        },
    };
}
function getKicadSchLayerByColorType(colorType, defaultType) {
    switch (colorType) {
        case 'default':
            return getKicadSchLayerByType(defaultType);
        case 'none':
            return undefined;
        case 'background':
            return getKicadSchLayerByType(SchLayerType.Background);
    }
    return getKicadSchLayerByType(defaultType);
}
function getKicadSchLayerByType(layer) {
    return exports.KicadSchLayerMap.get(layer);
}
function getKicadSchLayers() {
    return Array.from(exports.KicadSchLayerMap.values());
}
exports.PcbLayerMap = [
    { id: 0, name: ['F'], attribute: 'Cu', type: PcbLayerType.F, face: 'F', faceMirrorLayer: 31 },
    { id: 1, name: ['In1', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 2, name: ['In2', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 3, name: ['In3', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 4, name: ['In4', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 5, name: ['In5', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 6, name: ['In6', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 7, name: ['In7', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 8, name: ['In8', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 9, name: ['In9', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 10, name: ['In10', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 11, name: ['In11', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 12, name: ['In12', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 13, name: ['In13', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 14, name: ['In14', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 15, name: ['In15', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 16, name: ['In16', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 17, name: ['In17', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 18, name: ['In18', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 19, name: ['In19', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 20, name: ['In20', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 21, name: ['In21', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 22, name: ['In22', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 23, name: ['In23', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 24, name: ['In24', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 25, name: ['In25', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 26, name: ['In26', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 27, name: ['In27', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 28, name: ['In28', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 29, name: ['In29', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 30, name: ['In30', 'Inner'], attribute: 'Cu', type: PcbLayerType.Inner },
    { id: 31, name: ['B'], attribute: 'Cu', type: PcbLayerType.B, face: 'B', faceMirrorLayer: 0 },
    { id: 32, name: ['B'], attribute: 'Adhes', type: PcbLayerType.Other, face: 'B', faceMirrorLayer: 33 },
    { id: 33, name: ['F'], attribute: 'Adhes', type: PcbLayerType.Other, face: 'F', faceMirrorLayer: 32 },
    { id: 34, name: ['B'], attribute: 'Paste', type: PcbLayerType.Paste, face: 'B', faceMirrorLayer: 35 },
    { id: 35, name: ['F'], attribute: 'Paste', type: PcbLayerType.Paste, face: 'F', faceMirrorLayer: 34 },
    { id: 36, name: ['B'], attribute: 'SilkS', type: PcbLayerType.SilkS, face: 'B', faceMirrorLayer: 37 },
    { id: 37, name: ['F'], attribute: 'SilkS', type: PcbLayerType.SilkS, face: 'F', faceMirrorLayer: 36 },
    { id: 38, name: ['B'], attribute: 'Mask', type: PcbLayerType.Mask, face: 'B', faceMirrorLayer: 39 },
    { id: 39, name: ['F'], attribute: 'Mask', type: PcbLayerType.Mask, face: 'F', faceMirrorLayer: 38 },
    { id: 40, name: ['Dwgs'], attribute: 'User', type: PcbLayerType.Other },
    { id: 41, name: ['Cmts'], attribute: 'User', type: PcbLayerType.Other },
    { id: 42, name: ['Eco1'], attribute: 'User', type: PcbLayerType.Other },
    { id: 43, name: ['Eco2'], attribute: 'User', type: PcbLayerType.Other },
    { id: 44, name: ['Edge'], attribute: 'Cuts', type: PcbLayerType.Edge },
    { id: 45, name: ['Margin'], attribute: '', type: PcbLayerType.Other },
    { id: 46, name: ['B'], attribute: 'CrtYd', type: PcbLayerType.Other, face: 'B', faceMirrorLayer: 47 },
    { id: 47, name: ['F'], attribute: 'CrtYd', type: PcbLayerType.Other, face: 'F', faceMirrorLayer: 46 },
    { id: 48, name: ['B'], attribute: 'Fab', type: PcbLayerType.Other, face: 'B', faceMirrorLayer: 49 },
    { id: 49, name: ['F'], attribute: 'Fab', type: PcbLayerType.Other, face: 'F', faceMirrorLayer: 48 },
    { id: 50, name: ['User'], attribute: '1', type: PcbLayerType.Other, defaultVisible: false },
    { id: 51, name: ['User'], attribute: '2', type: PcbLayerType.Other, defaultVisible: false },
    { id: 52, name: ['User'], attribute: '3', type: PcbLayerType.Other, defaultVisible: false },
    { id: 53, name: ['User'], attribute: '4', type: PcbLayerType.Other, defaultVisible: false },
    { id: 54, name: ['User'], attribute: '5', type: PcbLayerType.Other, defaultVisible: false },
    { id: 55, name: ['User'], attribute: '6', type: PcbLayerType.Other, defaultVisible: false },
    { id: 56, name: ['User'], attribute: '7', type: PcbLayerType.Other, defaultVisible: false },
    { id: 57, name: ['User'], attribute: '8', type: PcbLayerType.Other, defaultVisible: false },
    { id: 58, name: ['User'], attribute: '9', type: PcbLayerType.Other, defaultVisible: false },
];
exports.KicadSchLayerMap = new Map([
    [SchLayerType.Label, { id: 1, type: SchLayerType.Label, name: 'Label' }],
    [SchLayerType.NameLabel, { id: 2, type: SchLayerType.NameLabel, name: 'NameLabel' }],
    [SchLayerType.ValueLabel, { id: 3, type: SchLayerType.ValueLabel, name: 'ValueLabel' }],
    [SchLayerType.Pin, { id: 4, type: SchLayerType.Pin, name: 'Pin' }],
    [SchLayerType.PinName, { id: 5, type: SchLayerType.PinName, name: 'PinName' }],
    [SchLayerType.PinNumber, { id: 6, type: SchLayerType.PinNumber, name: 'PinNumber' }],
    [SchLayerType.Symbol, { id: 7, type: SchLayerType.Symbol, name: 'Symbol' }],
    [SchLayerType.Wire, { id: 8, type: SchLayerType.Wire, name: 'Wire' }],
    [SchLayerType.Bus, { id: 9, type: SchLayerType.Bus, name: 'Bus' }],
    [SchLayerType.Junction, { id: 10, type: SchLayerType.Junction, name: 'Junction' }],
    [SchLayerType.BusJunction, { id: 11, type: SchLayerType.BusJunction, name: 'BusJunction' }],
    [SchLayerType.Other, { id: 12, type: SchLayerType.Other, name: 'Other' }],
    [SchLayerType.Background, { id: 13, type: SchLayerType.Background, name: 'Background Contrast' }],
    [SchLayerType.Image, { id: 14, type: SchLayerType.Image, name: 'Image' }],
]);
//# sourceMappingURL=layers.js.map